<template>
  <v-col lg="3" sm="6" md="7" cols="12">
    <v-card :loading="isLoading" height="100%">
      <v-card-title class="flex-nowrap pa-6 pb-3">
        <span class="text-truncate">{{ title }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-6 pt-0 mb-1">
        <v-row no-gutters>
          <v-col cols="12">
            <ApexChart
              v-if="countFaults && apexLoading"
              height="200"
              type="donut"
              class="mt-8"
              :options="options"
              :series="deviceActiveFaultsDistribution"
            ></ApexChart>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ApexChart from "vue-apexcharts";
import { devicesModule } from '@/store/modules/store-accessor'

import i18n from "@/i18n";

@Component({
  components: { ApexChart },
})
export default class DashboardCardPieChart extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly isLoading: boolean;

  apexLoading = false;

  mounted() {
    setTimeout(() => {
      this.apexLoading = true;
    });
  }

  get countFaults() {
    return devicesModule.deviceActiveFaultsChart[0] +  devicesModule.deviceActiveFaultsChart[1]
  }

  get deviceActiveFaultsDistribution() {
    return devicesModule.deviceActiveFaultsChart;
  }
  
  options = {
        chart: {
          width: 380,
          type: 'donut',
        },
        zoom: {
          allowMouseWheelZoom: false,
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270
          }
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'gradient',
        },
        legend: {
          formatter: function(val: any, opts: any) {
            if (opts.seriesIndex == 0 ) {
              return i18n.t("non_blocking");
            }
            else {
              return i18n.t("blocking");
            }
          }
        },
        labels: [i18n.t("non_blocking"), i18n.t("blocking")],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            zoom: {
              allowMouseWheelZoom: false,
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
  }
}
</script>

<style lang="scss">
@import "../../styles/app";

.dashboard-page {
  .page-title {
    padding-bottom: 20px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
  }
  .apexcharts-legend-series {
    padding: 2px 5px 3px;
    display: flex;
    align-items: center;
    .apexcharts-legend-marker {
      margin-right: 8px;
    }
  }
  .main-chart-select {
    font-size: 1rem;
    margin-right: 10px;
    fieldset {
      border-width: 1px !important;
      border-color: $text-grey !important;
      color: $text-grey !important;
    }
    .v-select__selection {
      color: $text-color !important;
    }
  }
  .v-card {
    .v-card__text {
      .subtext {
        font-size: 1.142rem;
        font-weight: 400;
        color: $title-grey;
      }
      .subtext-index {
        font-size: 11px;
        color: $text-color;
        font-weight: 400;
      }
    }
  }
}

.v-menu__content {
  box-shadow: $card-shadow !important;
  .v-list-item__content .v-list-item__title {
    font-size: 1rem;
    font-weight: 400;
  }
}
.button-shadow {
  box-shadow: $button-shadow;
}
</style>
